import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {useExpandedRows} from '../../../features/sub-issues/use-expanded-rows'
import {useTableHierarchy} from '../../../features/sub-issues/use-table-hierarchy'
import type {Row} from '../../../hooks/tanstack-table/types'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {BaseCell} from './base-cell'
import styles from './expand-cell.module.css'

export function ExpandCell({row}: {row: Row<MemexItemModel>}) {
  const {hierarchyEnabled} = useTableHierarchy()
  const {toggleRowExpanded} = useExpandedRows()
  if (!hierarchyEnabled) return null
  const expanded = 'getIsExpanded' in row && row.getIsExpanded()
  const expandable = 'getCanExpand' in row && row.getCanExpand()

  return (
    <BaseCell disallowSelection className={styles.cell}>
      {expandable ? (
        <IconButton
          icon={expanded ? ChevronDownIcon : ChevronRightIcon}
          aria-label={expanded ? 'Collapse' : 'Expand'}
          onClick={() => toggleRowExpanded(row.id)}
          tooltipDirection="w"
          variant="invisible"
        />
      ) : null}
    </BaseCell>
  )
}

try{ ExpandCell.displayName ||= 'ExpandCell' } catch {}